/** @file Distinct bone ids weighted by a skinned mesh, sorted (the bindPose key set, W2-29). */
import type { Id } from '@pose2d/format/types';

/** Every bone id appearing in `weights`, once each, in ascending id order. */
export function weightedBones(weights: readonly (readonly (readonly [Id, number])[])[]): Id[] {
  return [...new Set(weights.flat().map(([bone]) => bone))].sort();
}
